/**
 * WizardAudienceContext — Provider, der allen verschachtelten WizardStep-
 * Instanzen eine `audience`-Vorgabe gibt, ohne dass jeder Step explizit
 * die Prop weiterreichen muss.
 *
 * Hintergrund: TriageStep, IdentityStep usw. sind generisch geschrieben und
 * rendern <WizardStep> direkt. Wenn wir Mandanten-spezifisches Verhalten
 * (andere Navigation, andere Texte) wollen, ohne in jeden Step ein Prop zu
 * schmuggeln, lesen die Steps die audience aus diesem Context.
 *
 * Default ist 'berater' — bestehende Routen müssen nicht angefasst werden.
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { WizardAudience } from './WizardStep';

const WizardAudienceContext = createContext<WizardAudience>('berater');

export function WizardAudienceProvider({
  audience,
  children,
}: {
  audience: WizardAudience;
  children: ReactNode;
}) {
  return (
    <WizardAudienceContext.Provider value={audience}>{children}</WizardAudienceContext.Provider>
  );
}

export function useWizardAudience(): WizardAudience {
  return useContext(WizardAudienceContext);
}
